import React from 'react';
import PropTypes from 'prop-types';
import useActiveOffersForUser from '../useActiveOffersForUser';
import SectionHeader from '../../../components_profiles/SectionHeader';
import Offer from '../../offers/Offer';
import Loader from '../../../components/Loader';
import useShowMorePagination from '../shared/useShowMorePagination';
import useStableList from '../shared/useStableList';
import ShowMoreButton from '../shared/ShowMoreButton';

ActiveOffers.propTypes = {
  user: PropTypes.object.isRequired
};

export default function ActiveOffers(props) {
  const { user } = props;

  const { showAll, showMore, page, pageSize } = useShowMorePagination();
  const activeOffersRes = useActiveOffersForUser(user, { page, pageSize });
  const { data, isFetching, meta } = useStableList(activeOffersRes);

  const offersCount = data.length;
  const totalCount = (meta && meta.totalCount) || 0;
  const totalExtra = Math.max(0, totalCount - offersCount);

  function handleShowMore() { showMore(); }

  if (offersCount > 0) {
    return (
      <div className="space-y-4">
        <SectionHeader
          title="Active Offers"
          subtitle="Current experiences I'm offering to educators."
        />
        <div className="grid grid-cols-1 gap-4">
          {data.map(function(offer) {
            return (
              <Offer
                key={offer.id || offer.cid}
                offer={offer}
              />
            );
          })}
          {totalExtra > 0 && !showAll && (
            <ShowMoreButton count={totalExtra} onClick={handleShowMore} disabled={isFetching} noun="offers" />
          )}
          {isFetching && <Loader />}
        </div>
      </div>
    );
  }

  return null;
}
